export const indexedById = (selected = []) => {
  return selected.reduce((indexedObject, selectedItem) => {
    indexedObject[selectedItem.id] = selectedItem;
    return indexedObject;
  }, {});
};

export const objectToArray = (selectedObject = {}) => {
  return Object.entries(selectedObject).map((keyVal) => {
    const [key, value] = keyVal;
    return value;
  });
};

export const isArrayNotEmpty = (inputArray) => Array.isArray(inputArray) && inputArray.length > 0;

export const DEFAULT_POLLING_MS = 30000;

/**
 * Sets up a polling interval for the provided callback function.
 * @param {Function} $interval AngularJS interval service
 * @param {Function} fn Callback function
 * @param {number} intervalMs Delay between invocations
 */
export const pollOnInterval = ($interval, fn, intervalMs = DEFAULT_POLLING_MS) => {
  return $interval(() => {
    fn();
  }, intervalMs);
};
